import React from 'react'
import styled from 'styled-components'
import Text from 'core-system/Text/Text'
import palette from 'core-system/Themes/palette'
import { DashboardPeriod, DashboardProgramCard } from '../dashboardTypes'
import ProgramCard from './ProgramCard'

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1rem;

  @media (max-width: 1100px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 720px) {
    grid-template-columns: 1fr;
  }
`

const EmptyState = styled.div`
  padding: 1.5rem;
  border: 1px dashed ${palette.grey.grey300};
  border-radius: 0.75rem;
  text-align: center;
`

interface ProgramCardsRowProps {
  cards?: DashboardProgramCard[] | null
  isLoading?: boolean
  period?: DashboardPeriod
  onCardClick?: (card: DashboardProgramCard) => void
}

const ProgramCardsRow = ({
  cards = null,
  isLoading = false,
  period = 'all',
  onCardClick,
}: ProgramCardsRowProps) => {
  const showLoading = isLoading || cards === null
  const hasCards = (cards?.length ?? 0) > 0

  if (showLoading) {
    return (
      <EmptyState data-cy='program-cards-row'>
        <Text variant='body1' color={palette.text.secondary}>
          Loading programs…
        </Text>
      </EmptyState>
    )
  }

  if (!hasCards) {
    return (
      <EmptyState data-cy='program-cards-row'>
        <Text variant='body1' color={palette.text.secondary}>
          No active programs yet
        </Text>
      </EmptyState>
    )
  }

  return (
    <Grid data-cy='program-cards-row'>
      {cards!.map((card) => (
        <ProgramCard
          key={card.launchId}
          card={card}
          period={period}
          onClick={onCardClick}
        />
      ))}
    </Grid>
  )
}

export default React.memo(ProgramCardsRow)
